import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { UserContext } from "../../contexts/UserContext";

export default function LogCalls({
  expert_id,
  project_id,
  setExContactedBy,
  setExContactedMethod,
  setExDateCreated,
  backupData,
  setBackupData,
  doRefresh,
  setDoRefresh,
  currentExpertID,
  setCurrentExpertID,
}) {
  const { userData, userError, adminUser, msalAccount, notifications, setNotifications } =
    useContext(UserContext);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const handleLogCalls = () => {
    setLoadingPopup(true);
    const url = `${API_URL}log-calls`;
    const data = {
      expertID: expert_id,
      projectID: project_id,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "exception") {
          setExContactedBy(data.lastContact.contacted_by);
          setExContactedMethod(data.lastContact.mail_inmail);
          setExDateCreated(data.lastContact.Date_Created);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.Date_Created = data.lastContact.Date_Created;
                item.expert.contacted_by = data.lastContact.contacted_by;
                item.expert.mail_inmail = data.lastContact.mail_inmail;
              }
              return item;
            })
          );
          Swal.fire({
            icon: "info",
            title: "Error!",
            text: data.msg,
          });
        } else if (data.status === "success") {
          setCurrentExpertID(expert_id);
          setDoRefresh(!doRefresh);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Call logged successfully!",
          });
        } else if (data.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((error) => {
        setLoadingPopup(false);
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  return (
    <>
      <button
        className="btn"
        style={{ width: "130px" }}
        onClick={() => handleLogCalls()}
      >
        <i className="fa fa-phone" title="Click to Log Calss" /> Log Call
      </button>

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
